import { render, staticRenderFns } from "./EmployeeCardView.vue?vue&type=template&id=d0b65a56"
import script from "./EmployeeCardView.vue?vue&type=script&lang=js"
export * from "./EmployeeCardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports